// extracted by mini-css-extract-plugin
export default {"login":"Login_login__Ml1rg","heading":"Login_heading__uRPul","formControl":"Login_formControl__bXAiH","btn":"Login_btn__BcI8t"};